import { Modal } from 'antd'
import RenewalApplicationsModalContent from './RenewalApplicationsModalContent'
import React from 'react'

export default function RenewalApplicationsModal({
  open,
  onCancel,
}: {
  open: boolean
  onCancel?: () => void
}) {
  return (
    <Modal
      open={open}
      onCancel={onCancel}
      width={'100%'}
      style={{
        top: '10%',
        height: '90%',
        padding: '0 10%',
      }}
      footer={null}
    >
      <RenewalApplicationsModalContent onClose={onCancel} />
    </Modal>
  )
}
